import {Routes} from "@angular/router";
import {EmployeePanelRoutes} from "./employee-panel-routes";
import {CalendarComponent} from "./calendar/calendar.component";
import {ShiftsComponent} from "./shifts/shifts.component";
import {MyProfileComponent} from "./my-profile/my-profile.component";
import {SettingsComponent} from "./settings/settings.component";
import {EmployeeSubmissionsComponent} from "./submissions/employee-submissions.component";
import {EmployeeContactLinksComponent} from "./contacts/employee-contact-links.component";
import {EmployeeSubmissionDetailComponent} from "./submissions/employee-submission-detail.component";
import {EmployeeSubmissionEditComponent} from "./submissions/employee-submission-edit.component";
import {EnvironmentProviders, Provider} from "@angular/core";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {AuthInterceptor} from "../../_auth/auth.interceptor";

export const EMPLOYEEPANEL_ROUTES: Routes = [
  {path: EmployeePanelRoutes.Calendar, component: CalendarComponent, title: "Kalender"},
  {path: EmployeePanelRoutes.Shifts, component: ShiftsComponent, title: "Schichten"},
  {path: EmployeePanelRoutes.MyProfile, component: MyProfileComponent, title: "Profil"},
  {path: EmployeePanelRoutes.Settings, component: SettingsComponent, title: "Einstellungen"},
  {path: EmployeePanelRoutes.Submissions + '/:id/edit', component: EmployeeSubmissionEditComponent, title: "Formular überarbeiten"},
  {path: EmployeePanelRoutes.Submissions + '/:id', component: EmployeeSubmissionDetailComponent, title: "Formulareingabe"},
  {path: EmployeePanelRoutes.Submissions, component: EmployeeSubmissionsComponent, title: "Meine Formulare"},
  {path: EmployeePanelRoutes.Contacts, component: EmployeeContactLinksComponent, title: "Meine Verknüpfungen"},
  {path: '**', redirectTo: '' + EmployeePanelRoutes.Calendar, pathMatch: "full"},
]

export const EMPLOYEEPANEL_PROVIDERS: (Provider | EnvironmentProviders)[] = [
  {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
]

